document.addEventListener('DOMContentLoaded', function () {
    class ProductCard {
        constructor(element) {
            this.element = element;
            this.init();
        }

        init() {
            this.enableMouseHoverNavigation();
        }

        enableMouseHoverNavigation() {
            this.imageWrapper = this.element.querySelector('.product-card--image-wrapper');
            this.slider = this.element.querySelector('.product-card--image-inner');

            if (!this.imageWrapper || !this.slider) return;

            this.allImages = Array.from(this.slider.querySelectorAll('figure.aspect-ratio'));

            if (this.allImages.length <= 1) return;

            this.currentImageIndex = 0;
            this.totalImages = this.allImages.length;

            this.allImages.forEach((img, index) => {
                img.style.display = index === 0 ? 'block' : 'none';
            });

            this.imageWrapper.addEventListener('mousemove', (e) => {
                const rect = this.imageWrapper.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const imageWidth = rect.width;

                const imageIndex = Math.floor((x / imageWidth) * this.totalImages);
                const clampedIndex = Math.max(0, Math.min(imageIndex, this.totalImages - 1));

                if (clampedIndex !== this.currentImageIndex) {
                    this.currentImageIndex = clampedIndex;
                    this.showImage(clampedIndex);
                }
            });

            this.imageWrapper.addEventListener('mouseleave', () => {
                this.currentImageIndex = 0;
                this.showImage(0);
            });
        }

        showImage(index) {
            this.allImages.forEach((img) => {
                img.style.display = 'none';
            });
            this.allImages[index].style.display = 'block';
        }
    }

    function initProductCards() {
        document.querySelectorAll('.product-card:not([data-hover-initialized])').forEach((card) => {
            new ProductCard(card);
            card.setAttribute('data-hover-initialized', 'true');
        });
    }

    initProductCards();

    const observer = new MutationObserver(() => {
        if (document.querySelectorAll('.product-card:not([data-hover-initialized])').length > 0) {
            setTimeout(initProductCards, 100);
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    window.reinitProductCards = initProductCards;
});
